import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { SecurityDocService } from '../_services';
import * as SecurityDocActions from '../_actions/securityDoc';

@Injectable({
  providedIn: 'root',
})
export class SecurityDocEffects {
  loadSecurityDocs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SecurityDocActions.loadSecurityDocs),
      mergeMap(() =>
        this.securityDocService.getSecurityDocs().pipe(
          map((securityDocs) => SecurityDocActions.loadSecurityDocsSuccess({ securityDocs })),
          catchError((error) => of(SecurityDocActions.loadSecurityDocsFailure({ error })))
        )
      )
    )
  );

  addSecurityDoc$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SecurityDocActions.addSecurityDoc),
      mergeMap(({ securityDoc }) =>
        this.securityDocService.saveSecurityDoc(securityDoc).pipe(
          map((savedSecurityDoc) =>
            SecurityDocActions.addSecurityDocSuccess({ securityDoc: savedSecurityDoc })
          ),
          catchError((error) => of(SecurityDocActions.addSecurityDocFailure({ error })))
        )
      )
    )
  );

  updateSecurityDoc$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SecurityDocActions.updateSecurityDoc),
      mergeMap(({ securityDoc }) =>
        this.securityDocService.saveSecurityDoc(securityDoc).pipe(
          map((updatedSecurityDoc) =>
            SecurityDocActions.updateSecurityDocSuccess({ securityDoc: updatedSecurityDoc })
          ),
          catchError((error) => of(SecurityDocActions.updateSecurityDocFailure({ error })))
        )
      )
    )
  );

  deleteSecurityDoc$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SecurityDocActions.deleteSecurityDoc),
      mergeMap(({ id }) =>
        this.securityDocService.deleteSecurityDoc(id).pipe(
          map(() => SecurityDocActions.deleteSecurityDocSuccess({ id })),
          catchError((error) => of(SecurityDocActions.deleteSecurityDocFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private securityDocService: SecurityDocService
  ) {}
}
